$(document).ready(function () {
  //function to close menu
  $('.main-navbar').on('click', ' .open-menu', function () {

    $('.main-navbar .icon-menu').removeClass('open-menu');
    $('.main-navbar .icon-menu').addClass('closed-menu');

    $('.full-navbar').animate({
      height: 0,
    }, 800);

    setTimeout(function(){
      $('.full-navbar').css({
        display: 'none',
        height: '0',
      });

      $(".logo-incograf").css({
        //back to original position
        bottom: "240px",
        transition : 'bottom 0.9s ease-out'
      });

      $('body').css('overflow', 'auto');
    },700)
  });

  //function to open menu
  $('.main-navbar ').on('click', ' .closed-menu', function () {
    $('.main-navbar .icon-menu').removeClass('closed-menu');
    $('.main-navbar .icon-menu').addClass('open-menu');

    $('.full-navbar').css({
      display: 'block',
      height:'100vh',
      animation: 'fadeInUpBig',
      animationDuration: '700ms'
    });

    $('body').css('overflow', 'hidden');

    $(".logo-incograf").css({
      bottom: "50px",
      transition: 'bottom 0.9s ease-in-out'
    });
  });
});
